import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645e16ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-block",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "table is-fullwidth" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "sizeby" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_7 = { class: "sizeby" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (cat, i) => {
            return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(_ctx.translateCategoryKey(cat)), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('networkmsg')
          }, _toDisplayString(_ctx.t("networksize")), 9, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(_ctx.networkSize[i]), 1))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.t("sizebygender")) + " ", 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("female")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("male")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("diverse")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("notspecified")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeByGender[i], (gSize, j) => {
                return (_openBlock(), _createElementBlock("p", { key: j }, _toDisplayString(gSize), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.t("sizebyhorizon")) + " ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HORIZON_KEYS, (ho, i) => {
              return (_openBlock(), _createElementBlock("em", {
                key: 'hl' + i
              }, _toDisplayString(_ctx.t(ho)), 1))
            }), 128))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeByHorizon[i], (hSz, j) => {
                return (_openBlock(), _createElementBlock("p", { key: j }, _toDisplayString(hSz), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('closenessmsg')
          }, _toDisplayString(_ctx.t("closeness")), 9, _hoisted_9),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(_ctx.naehen[i]), 1))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('densitymsg')
          }, _toDisplayString(_ctx.t("categorydensity")), 9, _hoisted_10),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(_ctx.density[i]), 1))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('degreemsg')
          }, _toDisplayString(_ctx.t("degree")), 9, _hoisted_11),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (_, i) => {
            return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(_ctx.degree[i]), 1))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('starsmsg')
          }, _toDisplayString(_ctx.t("categorystar")), 9, _hoisted_12),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (cat, i) => {
            return (_openBlock(), _createElementBlock("td", {
              key: i,
              onClick: ($event: any) => (_ctx.clickCell('stars', cat)),
              class: _normalizeClass({ clickAble: _ctx.stars[i] != '-' })
            }, _toDisplayString(_ctx.stars[i]), 11, _hoisted_13))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('isolatedmsg')
          }, _toDisplayString(_ctx.t("isolatedpersons")), 9, _hoisted_14),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (cat, i) => {
            return (_openBlock(), _createElementBlock("td", {
              key: i,
              onClick: ($event: any) => (_ctx.clickCell('isolated', cat)),
              class: _normalizeClass({ clickAble: _ctx.isolated[i] != '0' })
            }, _toDisplayString(_ctx.isolated[i]), 11, _hoisted_15))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('noedgemsg')
          }, _toDisplayString(_ctx.t("personswithoutedgetotheego")), 9, _hoisted_16),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (cat, i) => {
            return (_openBlock(), _createElementBlock("td", {
              key: i,
              onClick: ($event: any) => (_ctx.clickCell('alterZeroEdge', cat)),
              class: _normalizeClass({ clickAble: _ctx.alterZeroEdge[i] != '0' })
            }, _toDisplayString(_ctx.alterZeroEdge[i]), 11, _hoisted_17))
          }), 128))
        ])
      ])
    ])
  ]))
}